import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createSlots as _createSlots } from "vue"

const _hoisted_1 = { id: "app-root" }
const _hoisted_2 = { key: 4 }
const _hoisted_3 = { key: 5 }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-uppercase text-black text-body-large mr-3"
}
const _hoisted_7 = ["src"]

export function render(_ctx, _cache) {
  const _component_asking_dialog_box = _resolveComponent("asking-dialog-box")
  const _component_disa_chat_dialog_box = _resolveComponent("disa-chat-dialog-box")
  const _component_v_layout = _resolveComponent("v-layout")
  const _component_v_container = _resolveComponent("v-container")
  const _component_v_card_text = _resolveComponent("v-card-text")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_dialog = _resolveComponent("v-dialog")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_snackbar = _resolveComponent("v-snackbar")
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")
  const _component_v_img = _resolveComponent("v-img")
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")
  const _component_v_spacer = _resolveComponent("v-spacer")
  const _component_own_user_location_department_select = _resolveComponent("own-user-location-department-select")
  const _component_own_attendee_select = _resolveComponent("own-attendee-select")
  const _component_d4y_img = _resolveComponent("d4y-img")
  const _component_v_card_actions = _resolveComponent("v-card-actions")
  const _component_v_menu = _resolveComponent("v-menu")
  const _component_web_push_messages = _resolveComponent("web-push-messages")
  const _component_v_avatar = _resolveComponent("v-avatar")
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")
  const _component_v_list_item = _resolveComponent("v-list-item")
  const _component_v_divider = _resolveComponent("v-divider")
  const _component_v_list = _resolveComponent("v-list")
  const _component_v_tooltip = _resolveComponent("v-tooltip")
  const _component_v_app_bar = _resolveComponent("v-app-bar")
  const _component_v_list_group = _resolveComponent("v-list-group")
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")
  const _component_trial_expiry_information = _resolveComponent("trial-expiry-information")
  const _component_router_view = _resolveComponent("router-view")
  const _component_v_main = _resolveComponent("v-main")
  const _component_v_app = _resolveComponent("v-app")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_asking_dialog_box, { ref: "askingDialogBox" }, null, 512),
    _createVNode(_component_disa_chat_dialog_box, {
      modelValue: _ctx.showDisaChat,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showDisaChat) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showDialog) = $event)),
      "max-width": "1000px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { "grid-list-md": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_layout, { wrap: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("b", null, _toDisplayString(_ctx.$t('app.auto_logout',{minutes: _ctx.actualMinutes, seconds:
              _ctx.actualSeconds})), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: _ctx.askForNativeNotificationPermission,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.askForNativeNotificationPermission) = $event)),
      "max-width": "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "text-center text-body-large py-2" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('app.webpush.overlay_text')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_ctx.isKioskMode)
      ? (_openBlock(), _createBlock(_component_v_app, {
          key: 0,
          "full-height": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_snackbar, {
              location: "bottom right",
              "model-value": _ctx.update.updateExists.value,
              timeout: -1,
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('app.pwa_update.message')) + " ", 1),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _ctx.update.refreshApp
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('app.pwa_update.button_name')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["model-value"]),
            _createVNode(_component_v_app_bar, {
              height: "60",
              width: _ctx.appbarWidth,
              elevation: "1"
            }, _createSlots({
              prepend: _withCtx(() => [
                (_ctx.isLoggedIn && !_ctx.isTrialExpired)
                  ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.drawer = !_ctx.drawer), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.drawer ? 'mdi-close' : 'mdi-menu'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.mobileXs)
                  ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 1 }, {
                      default: _withCtx(() => [
                        (_ctx.getterSettings.logoFile != '')
                          ? (_openBlock(), _createBlock(_component_v_img, {
                              key: 0,
                              src: _ctx.getterSettings.logoFile,
                              "aspect-ratio": "1.0",
                              onClick: _ctx.onClickLogo,
                              height: "60",
                              width: "60",
                              class: "ml-2 pointer-cursor"
                            }, null, 8, ["src", "onClick"]))
                          : (_openBlock(), _createBlock(_component_v_img, {
                              key: 1,
                              src: require('@/assets/attmag-logo.png'),
                              "aspect-ratio": "1.0",
                              onClick: _ctx.onClickLogo,
                              height: "60",
                              width: "60",
                              class: "ml-2 pointer-cursor"
                            }, null, 8, ["src", "onClick"]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              append: _withCtx(() => [
                (!_ctx.isTrialExpired)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.mobile ? 'd-flex' : 'd-flex mr-2')
                    }, [
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "",
                            size: _ctx.mobileXs ? 36 : 46,
                            onClick: _ctx.openDisaChat
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_d4y_img, {
                                src: require(`@/assets/disa-chat.svg`),
                                size: _ctx.mobileXs ? 36 : 40,
                                round: ""
                              }, null, 8, ["src", "size"])
                            ]),
                            _: 1
                          }, 8, ["size", "onClick"]))
                        : _createCommentVNode("", true),
                      (!_ctx.mobile || !_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            icon: "",
                            onClick: _cache[4] || (_cache[4] = $event => (_ctx.setLocale(_ctx.$i18n.locale =='en' ? 'de' : 'en')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_d4y_img, {
                                src: _ctx.$i18n.locale =='de' ? require(`@/assets/en-flag.svg`) : require(`@/assets/de-flag.svg`),
                                size: "34",
                                round: ""
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn && ( _ctx.isAdmin || _ctx.isManager || _ctx.isEmployee || _ctx.isTrainer ))
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 2,
                            icon: "",
                            size: _ctx.mobileXs ? 40 : 48,
                            onClick: _ctx.onClickScanner
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_d4y_img, {
                                src: require(`../../assets/checkIn_scanner.svg`),
                                height: "30",
                                width: "30"
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          }, 8, ["size", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoggedIn && _ctx.isAttendee)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 3,
                            icon: "",
                            size: _ctx.mobileXs ? 42 : 48,
                            onClick: _ctx.onClickQrCode
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "40" }, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode(" mdi-qrcode ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["size", "onClick"]))
                        : _createCommentVNode("", true),
                      (!_ctx.isEmailConfirmed && _ctx.currentRouteName===_ctx.$ROUTES.home)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_v_menu, {
                              location: "bottom left",
                              modelValue: _ctx.menuResendEmail,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.menuResendEmail) = $event)),
                              "max-width": 400,
                              "close-on-content-click": false
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({ size: "small" }, props, {
                                  icon: "",
                                  size: _ctx.mobileXs ? 36 : 46
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "red",
                                      size: _ctx.mobileXs ? 36 : 40
                                    }, {
                                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createTextVNode(" mdi-alert-rhombus ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["size"])
                                  ]),
                                  _: 1
                                }, 16, ["size"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { class: "text-body-large pl-5" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('app.confirmation.message1')), 1),
                                        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('app.confirmation.message2')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          variant: "flat",
                                          color: "error",
                                          onClick: _cache[5] || (_cache[5] = $event => (_ctx.menuResendEmail = false))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('app.menu.popover.subscription_close')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_btn, {
                                          variant: "flat",
                                          color: "primary",
                                          onClick: _cache[6] || (_cache[6] = $event => (_ctx.resend()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('app.confirmation.action')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : (_ctx.askForWebPushSubscription && _ctx.currentRouteName===_ctx.$ROUTES.home)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createVNode(_component_v_menu, {
                                location: "bottom left",
                                modelValue: _ctx.askForWebPushSubscription,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.askForWebPushSubscription) = $event)),
                                "max-width": 400,
                                "close-on-content-click": false
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    icon: "",
                                    size: _ctx.mobileXs ? 36 : 46
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        color: "error",
                                        size: _ctx.mobileXs ? 36 : 38
                                      }, {
                                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                          _createTextVNode(" mdi-bell-cog ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["size"])
                                    ]),
                                    _: 1
                                  }, 16, ["size"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_text, { class: "text-body-large pl-5" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('app.webpush.message1')), 1),
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_v_icon, {
                                                color: "primary",
                                                size: "34"
                                              }, {
                                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                  _createTextVNode(" mdi-bell ", -1)
                                                ]))]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('app.webpush.message2')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_actions, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_spacer),
                                          _createVNode(_component_v_btn, {
                                            variant: "flat",
                                            color: "error",
                                            onClick: _cache[8] || (_cache[8] = $event => (_ctx.webPushSubscriptionDeny()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('app.webpush.deny')), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_btn, {
                                            variant: "flat",
                                            color: "primary",
                                            onClick: _cache[9] || (_cache[9] = $event => (_ctx.webPushSubscriptionGrant()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('app.webpush.grant')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_ctx.showWebPushMessagesBell && _ctx.currentRouteName===_ctx.$ROUTES.home && !_ctx.mobileXs)
                            ? (_openBlock(), _createBlock(_component_web_push_messages, {
                                key: 6,
                                class: "mt-1"
                              }))
                            : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 1,
                      "open-on-click": "",
                      transition: false
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _mergeProps(props, { class: "pointer-cursor d-flex align-center" }), [
                          (!_ctx.mobile)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedContact.lastName + " " + _ctx.selectedContact.firstName), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_avatar, { class: "pa-5 account-border-color" }, {
                            default: _withCtx(() => [
                              (_ctx.selectedContactLogo)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.selectedContactLogo,
                                    class: "avatar-image-size"
                                  }, null, 8, _hoisted_7))
                                : (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    color: "black",
                                    size: "36"
                                  }, {
                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                      _createTextVNode("mdi-account", -1)
                                    ]))]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, {
                          density: "comfortable",
                          "min-width": "220",
                          class: "menu-list"
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.isTrialExpired)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  to: `/${_ctx.$ROUTES.my_profile}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode("mdi-account-edit", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", null, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.edit_profile']
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.mobile)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  onClick: _cache[11] || (_cache[11] = $event => (_ctx.setLocale(_ctx.$i18n.locale =='en' ? 'de' : 'en')))
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      size: "20",
                                      src: _ctx.$i18n.locale =='de' ? require(`../../assets/en-flag.svg`) : require(`../../assets/de-flag.svg`),
                                      round: ""
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "ml-9" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.switchLanguage']
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_list_item, { onClick: _ctx.onClickQrCode }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("mdi-qrcode", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.showQrCode']
                                ])
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            (_ctx.isAttendee)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 2,
                                  to: `/${_ctx.$ROUTES.my_membership}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                        _createTextVNode("mdi-text-box-check", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", null, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.my_membership']
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.isAttendee)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 3,
                                  to: `/${_ctx.$ROUTES.my_invoices}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                        _createTextVNode("mdi-account-card", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", null, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.my_invoices']
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.isAttendee)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 4,
                                  to: `/${_ctx.$ROUTES.my_documents}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                        _createTextVNode("mdi-file-document", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", null, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.my_documents']
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.perms.myCompanyViewEdit)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 5,
                                  to: `/${_ctx.$ROUTES.my_company}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                        _createTextVNode("mdi-office-building", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", null, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.edit_company']
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.perms.companySubscriptionsViewEdit)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 6,
                                  to: `/${_ctx.$ROUTES.company_subscriptions}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                        _createTextVNode("mdi-cash-multiple", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.company-subscriptions']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.perms.statisticsViewCreate)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 7,
                                  to: `/${_ctx.$ROUTES.statistics}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                        _createTextVNode("mdi-chart-line", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.statistics']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.perms.referencesView)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 8,
                                  to: `/${_ctx.$ROUTES.reference_tables}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                        _createTextVNode("mdi-book-edit", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.reference_tables']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.perms.settingsViewEdit)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 9,
                                  to: `/${_ctx.$ROUTES.settings}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                        _createTextVNode("mdi-tools", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.settings']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_divider),
                            (_ctx.isLoggedIn)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 10,
                                  to: `/${_ctx.$ROUTES.feedback_and_support}`
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                        _createTextVNode("mdi-bullhorn", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                      [_directive_t, 'app.menu.feedback']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_list_item, {
                              to: `/${_ctx.$ROUTES.terms_and_conditions}`
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                    _createTextVNode("mdi-information", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                  [_directive_t, 'app.menu.terms_and_conditions']
                                ])
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _withDirectives(_createVNode(_component_v_divider, null, null, 512), [
                              [_vShow, _ctx.isLoggedIn]
                            ]),
                            _createVNode(_component_v_list_item, { onClick: _ctx.logout }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "action_logout" }, {
                                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                    _createTextVNode("mdi-exit-to-app", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, null, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.signout']
                                ])
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 2,
                      text: _ctx.$t('app.menu.navdrawer.join'),
                      location: "bottom"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          style: {"background-color":"#383838 !important"},
                          variant: "elevated",
                          onClick: _ctx.join
                        }, props), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "large",
                              color: "white"
                            }, {
                              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                _createTextVNode("mdi-account-plus", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 16, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (!_ctx.isTrialExpired)
                ? {
                    name: "default",
                    fn: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      (_ctx.showOwnUserLocationSelection)
                        ? (_openBlock(), _createBlock(_component_own_user_location_department_select, {
                            key: 0,
                            showDepartments: _ctx.currentRouteName!==_ctx.$ROUTES.public_view
                          }, null, 8, ["showDepartments"]))
                        : (_ctx.showOwnContactsSelection)
                          ? (_openBlock(), _createBlock(_component_own_attendee_select, { key: 1 }))
                          : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["width"]),
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
                  key: 0,
                  modelValue: _ctx.drawer,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.drawer) = $event)),
                  app: "",
                  "disable-resize-watcher": "",
                  floating: !_ctx.mobile,
                  top: _ctx.mobile,
                  absolute: _ctx.mobile,
                  temporary: _ctx.mobile,
                  permanent: _ctx.drawer && !_ctx.mobile,
                  "mini-variant": _ctx.mini,
                  class: "mobile-drawer",
                  color: "primary",
                  width: "300"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      nav: "",
                      class: "app-list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          to: "/",
                          "base-color": "white"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_d4y_img, {
                              width: "23",
                              src: require('@/assets/icons/home.svg'),
                              class: "mr-8"
                            }, null, 8, ["src"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "text-body-large" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("span", null, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.home']
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.perms.locationsView)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              to: `/${_ctx.$ROUTES.locations}`,
                              active: _ctx.locationLinkActive,
                              "base-color": "white"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_d4y_img, {
                                  width: "23",
                                  src: require('@/assets/icons/location.svg'),
                                  class: "mr-8"
                                }, null, 8, ["src"])
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.locations']
                                ])
                              ]),
                              _: 1
                            }, 8, ["to", "active"]))
                          : _createCommentVNode("", true),
                        (_ctx.perms.employeesView)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              to: `/${_ctx.$ROUTES.employees}`,
                              active: _ctx.employeesLinkActive,
                              "base-color": "white"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_d4y_img, {
                                  width: "23",
                                  src: require('../../assets/icons/employee.svg'),
                                  class: "mr-8"
                                }, null, 8, ["src"])
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.employees']
                                ])
                              ]),
                              _: 1
                            }, 8, ["to", "active"]))
                          : _createCommentVNode("", true),
                        (_ctx.perms.trainersView)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              to: `/${_ctx.$ROUTES.trainers}`,
                              active: _ctx.trainersLinkActive,
                              "base-color": "white"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_d4y_img, {
                                  width: "23",
                                  src: require('@/assets/icons/trainer.svg'),
                                  class: "mr-8"
                                }, null, 8, ["src"])
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.trainers']
                                ])
                              ]),
                              _: 1
                            }, 8, ["to", "active"]))
                          : _createCommentVNode("", true),
                        (_ctx.perms.coursesView || _ctx.perms.dateTimesView || _ctx.perms.appointmentsView)
                          ? (_openBlock(), _createBlock(_component_v_list_group, {
                              key: 3,
                              "base-color": "white"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, { "base-color": "white" }), {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      width: "23",
                                      src: require('@/assets/icons/courses.svg'),
                                      class: "mr-8"
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.courses_appointments']
                                    ])
                                  ]),
                                  _: 1
                                }, 16)
                              ]),
                              default: _withCtx(() => [
                                (_ctx.perms.coursesView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      to: `/${_ctx.$ROUTES.courses}`,
                                      active: _ctx.coursesLinkActive,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "23",
                                          src: require('@/assets/icons/courses.svg'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.courses']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to", "active"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.dateTimesView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      to: `/${_ctx.$ROUTES.courses_coursetimes}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "32",
                                          src: require('@/assets/icons/course-times-white.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.course_times']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.appointmentsView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      to: `/${_ctx.$ROUTES.courses_appointments}`,
                                      active: _ctx.appointmentsLinkActive,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_img, {
                                          width: "23",
                                          src: require('../../assets/icons/appointments-white.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.appointments']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to", "active"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.perms.employeesView)
                          ? (_openBlock(), _createBlock(_component_v_list_group, {
                              key: 4,
                              "base-color": "white"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, { "base-color": "white" }), {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      width: "23",
                                      src: require('@/assets/icons/attendances.svg'),
                                      class: "mr-8"
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.attendances']
                                    ])
                                  ]),
                                  _: 1
                                }, 16)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  to: `/${_ctx.$ROUTES.attendances}`,
                                  "base-color": "white"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      width: "23",
                                      src: require('@/assets/icons/attendances.svg'),
                                      class: "mr-8"
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.attendances']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"]),
                                _createVNode(_component_v_list_item, {
                                  to: `/${_ctx.$ROUTES.attendances_presences}`,
                                  "base-color": "white"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      width: "26",
                                      src: require('@/assets/icons/presences-white.png'),
                                      class: "mr-8"
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.presence']
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["to"])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 5,
                              to: `/${_ctx.$ROUTES.attendances}`,
                              "base-color": "white"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_d4y_img, {
                                  width: "23",
                                  src: require('@/assets/icons/attendances.svg'),
                                  class: "mr-8"
                                }, null, 8, ["src"])
                              ]),
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.attendances']
                                ])
                              ]),
                              _: 1
                            }, 8, ["to"])),
                        (_ctx.perms.invoicesView ||
            _ctx.perms.invoicePositionsView ||
            _ctx.perms.invoiceRunsView ||
            _ctx.perms.trainerPayrollsView ||
            _ctx.perms.directDebitViewCreate)
                          ? (_openBlock(), _createBlock(_component_v_list_group, {
                              key: 6,
                              "base-color": "white"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, { "base-color": "white" }), {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      width: "23",
                                      src: require('@/assets/icons/invoices.png'),
                                      class: "mr-8"
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.invoices']
                                    ])
                                  ]),
                                  _: 1
                                }, 16)
                              ]),
                              default: _withCtx(() => [
                                (_ctx.perms.invoicesView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      to: `/${_ctx.$ROUTES.invoices}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "23",
                                          src: require('@/assets/icons/invoices.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.invoices']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.invoicePositionsView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      to: `/${_ctx.$ROUTES.invoice_items}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "23",
                                          src: require('@/assets/icons/single-costs-white.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.single_costs']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.invoiceRunsView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      to: `/${_ctx.$ROUTES.invoice_runs}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "23",
                                          src: require('@/assets/icons/invoice-runs-white.svg'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.invoice_runs']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.trainerPayrollsView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 3,
                                      to: `/${_ctx.$ROUTES.trainer_payrolls}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "23",
                                          src: require('@/assets/icons/trainer-payroll-white.svg'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.trainer_payrolls']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.directDebitViewCreate)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 4,
                                      to: `/${_ctx.$ROUTES.sepa_files}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_icon, { width: "23" }, {
                                          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                            _createTextVNode("mdi-currency-eur", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.sepa_files']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.perms.attendeesView || _ctx.perms.interestedView)
                          ? (_openBlock(), _createBlock(_component_v_list_group, {
                              key: 7,
                              "base-color": "white"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps(props, { "base-color": "white" }), {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_d4y_img, {
                                      width: "23",
                                      src: require('../../assets/icons/attendee.svg'),
                                      class: "mr-8"
                                    }, null, 8, ["src"])
                                  ]),
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                      [_directive_t, 'app.menu.navdrawer.attendee_interested']
                                    ])
                                  ]),
                                  _: 1
                                }, 16)
                              ]),
                              default: _withCtx(() => [
                                (_ctx.perms.attendeesView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      to: `/${_ctx.$ROUTES.attendees}`,
                                      active: _ctx.attendeesLinkActive,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_d4y_img, {
                                          width: "35",
                                          src: require('../../assets/icons/attendees.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, _ctx.isAdmin || _ctx.isManager || _ctx.isEmployee
                ? 'app.menu.navdrawer.attendees'
                : 'app.menu.navdrawer.my-attendees']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to", "active"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.attendeesView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      to: `/${_ctx.$ROUTES.attendee_presences}`,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_img, {
                                          width: "26",
                                          src: require('@/assets/icons/presences-white.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.attendee_presence']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                (_ctx.perms.interestedView)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 2,
                                      to: `/${_ctx.$ROUTES.attendees_interested}`,
                                      active: _ctx.interestedLinkActive,
                                      "base-color": "white"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_img, {
                                          width: "23",
                                          src: require('@/assets/icons/attendees_interested.png'),
                                          class: "mr-8"
                                        }, null, 8, ["src"])
                                      ]),
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                          [_directive_t, 'app.menu.navdrawer.interested']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["to", "active"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.perms.statisticsViewCreate)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 8,
                              to: `/${_ctx.$ROUTES.statistics}`,
                              "base-color": "white"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  width: "23",
                                  class: "mr-8"
                                }, {
                                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                    _createTextVNode(" mdi-chart-line ", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _withDirectives(_createVNode(_component_v_list_item_title, { class: "text-body-large" }, null, 512), [
                                  [_directive_t, 'app.menu.navdrawer.statistics']
                                ])
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "floating", "top", "absolute", "temporary", "permanent", "mini-variant"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_main, { scrollable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_trial_expiry_information),
                _createVNode(_component_router_view)
              ]),
              _: 1
            }),
            _createVNode(_component_v_snackbar, {
              top: "",
              modelValue: _ctx.snackbar.show,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.snackbar.show) = $event)),
              color: _ctx.snackbar.color,
              timeout: _ctx.snackbar.duration,
              "close-on-content-click": "",
              right: ""
            }, {
              action: _withCtx(({ attrs }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  dark: "",
                  text: ""
                }, attrs, {
                  onClick: _cache[13] || (_cache[13] = $event => (_ctx.releaseSnackbar()))
                }), {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode(" Ok ", -1)
                  ]))]),
                  _: 1
                }, 16)
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.snackbar.text) + " ", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "color", "timeout"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_app, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_main, { scrollable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}